import { ModalConfirm } from '@/components/element/modal/ModalConfirm';
import { OrderAllocatedExpense } from '@/hooks/api/models';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDestroyOrderAllocatedExpense } from '@/hooks/api/1195_destroy_order_allocated_expense';
import { useInvalidateOrderAllocatedExpenses } from '@/hooks/api/1192_order_allocated_expenses';
import { NonAllocatedExpenseRow } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskOrderAllocatedExpenseEditForm/PaymentTaskOrderAllocatedExpensesElement/NonAllocatedExpenseRow';
import { AllocatedExpenseRow } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskOrderAllocatedExpenseEditForm/PaymentTaskOrderAllocatedExpensesElement/AllocatedExpenseRow';

export const PaymentTaskOrderAllocatedExpensesElement = ({
  orderAllocatedExpenses,
}: {
  orderAllocatedExpenses: OrderAllocatedExpense[];
}) => {
  const { setShowLoading } = useLoading();
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const [delTarget, setDelTarget] = useState<OrderAllocatedExpense>();
  const {
    mutate: destroyMutate,
    isSuccess: destroyIsSuccess,
    isPending: destroyIsPending,
  } = useDestroyOrderAllocatedExpense();
  const { invalidate } = useInvalidateOrderAllocatedExpenses({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    task_id: task!.id,
  });

  useEffect(() => {
    if (destroyIsSuccess) {
      invalidate();
    }
  }, [destroyIsSuccess]);

  useEffect(() => setShowLoading(destroyIsPending), [destroyIsPending]);

  const onDeleteClick = () => {
    setShowLoading(true);
    destroyMutate({
      identifier: _w_!.identifier,
      team_id: _t_!.id,
      purchase_order_id: Number(purchase_order_id),
      task_id: task!.id,
      id: delTarget!.id,
    });
  };

  return (
    <div className="table-responsive">
      <ModalConfirm modalId={`delConfirm`} okClicked={() => onDeleteClick()} message={'削除します。よろしいですか？'} />

      <table className="table align-items-center">
        <thead>
          <tr>
            <th className="text-secondary text-xxs font-weight-bolder opacity-7 px-2">関連プロジェクト</th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2 text-end" style={{ width: 150 }}>
              金額
            </th>
            <th className="text-secondary text-xxs font-weight-bold opacity-7 px-2" style={{ width: 100 }}></th>
          </tr>
        </thead>
        <tbody>
          <NonAllocatedExpenseRow />

          {orderAllocatedExpenses.map((d) => (
            <AllocatedExpenseRow key={`aer-${d.id}`} d={d} setDelTarget={setDelTarget} />
          ))}
        </tbody>
      </table>
    </div>
  );
};
